import { GOOGLE_AUTHENTICATION_SUCCEEDED, GOOGLE_API_LOAD_SUCCEEDED } from 'documents-lib/js/constants/ActionTypes';
const initialState = {
  isLoaded: false,
  googleAuthToken: null
};
export default ((state = initialState, action) => {
  switch (action.type) {
    case GOOGLE_API_LOAD_SUCCEEDED:
      return Object.assign({}, state, {
        isLoaded: true
      });
    case GOOGLE_AUTHENTICATION_SUCCEEDED:
      return Object.assign({}, state, {
        googleAuthToken: action.payload
      });
    default:
      return state;
  }
});